import React from 'react';
import styled from 'styled-components';

export default function RadioBox({
  value,
  onChange,
  checked,
  name,
  children
}: {
  value: number;
  onChange(value: boolean): void;
  checked: boolean;
  name: string;
  children: React.ReactNode
}) {
  return <Container>
    <label>
      <input type="radio" name={name} value={value} checked={checked} onChange={() => onChange(!value)} />
      <div>{children}</div>
    </label>
</Container>
}

const Container = styled.div`
  line-height: 20px;

  & input {
    position: absolute;
    z-index: -1;
    left: 0;
    top: 0;
  }

  & div {
    position: relative;
    padding-left: 30px;
    display: inline-block;
  }

  & div::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    border: 1px solid var(--green);
    border-radius: 4px;
  }

  & input:checked + div::after {
    content: '';
    font-family: var(--font-awesome);
    position: absolute;
    left: 3px;
    top: 0;
  }

  & a {
    color: var(--green);
  }
`